import {useState, useEffect} from 'react'

import {Col, Form, Modal, Row} from 'react-bootstrap'
import Api from '../../../../thesis-and-dissertations/helpers/api'
import {toast} from 'react-toastify'
import {dateFormat} from 'thesis-and-dissertations/helpers/helper'
const api = new Api()

type Props = {
  isShow: boolean
  handleShow: any
  data: any
  handleRefresh: any
}

const ChangePeriod: React.FC<Props> = ({isShow, handleShow, data, handleRefresh}) => {
  const [formValue, setFormValue] = useState<any>({})
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<any>({})

  useEffect(() => {
    setFormValue({
      expired_date: dateFormat(data?.company_jobs_expired_date),
      id: data?.company_job_id,
    })
  }, [data])

  const handleClose = () => {
    handleShow(false)
    setErrors({})
  }

  const handleSave = () => {
    setLoading(true)
    api
      .changePeriodJob(formValue, formValue?.id)
      .then((response: any) => {
        setLoading(false)
        const {data} = response
        toast.success(data?.meta?.message)
        handleRefresh(true)
        handleClose()
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
        setErrors(data?.meta?.error)
        toast.error(data?.meta?.message)
      })
  }

  return (
    <Modal show={isShow} centered size='lg'>
      <div className='p-10'>
        <Form>
          <Row>
            <Col md={12}>
              <Form.Group>
                <Form.Label>
                  Periode Lowongan<i className='text-danger'>*</i>
                </Form.Label>

                <div>
                  <input
                    type='date'
                    className={`form-control pe-5 ${errors?.expired_date && 'border-danger'}`}
                    placeholder='Masukan email/NIK'
                    value={formValue?.expired_date}
                    onChange={(e) => {
                      setFormValue({...formValue, expired_date: e.target.value})
                    }}
                  />
                </div>

                {errors?.expired_date && <p className='text-danger mt-1'>{errors?.expired_date}</p>}
              </Form.Group>
            </Col>
          </Row>
        </Form>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          disabled={loading}
          onClick={handleSave}
        >
          Simpan
        </button>

        <button
          type='button'
          onClick={handleClose}
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

export default ChangePeriod
